<div class="legal">
  <div class="container">
    <h2 class="line-title legal__line-title">Legal</h2>
    <!-- /.legal__btn-wrappe -->
    <div class="legal__content">
      <div class="legal-sidebar">
        <ul class="legal-sidebar__items-list">
          <li class="legal-sidebar__item">
            <a
              [class.legal-sidebar__item-link_active]="
                activeTab === 'Cancellation Policy'
              "
              (click)="selectTable('Cancellation Policy')"
              class="legal-sidebar__item-link"
              >Cancellation Policy</a
            >
            <figure class="legal-sidebar__triangle-btn"></figure>
          </li>
          <app-cancellation-policy
            *ngIf="activeTab === 'Cancellation Policy'"
            class="legal__table legal__table_mobile"
          >
          </app-cancellation-policy>
          <li class="legal-sidebar__item">
            <a
              [class.legal-sidebar__item-link_active]="
                activeTab === 'E911 Calling Policy'
              "
              (click)="selectTable('E911 Calling Policy')"
              class="legal-sidebar__item-link"
              >E911 Calling Policy</a
            >
            <figure class="legal-sidebar__triangle-btn"></figure>
          </li>

          <app-calling-policy
            *ngIf="activeTab === 'E911 Calling Policy'"
            class="legal__table legal__table_mobile"
          >
          </app-calling-policy>
          <li class="legal-sidebar__item">
            <a
              [class.legal-sidebar__item-link_active]="
                activeTab === 'SipSignal Acceptabl Use Policy'
              "
              (click)="selectTable('SipSignal Acceptabl Use Policy')"
              class="legal-sidebar__item-link"
              >SipSignal Acceptabl Use Policy</a
            >
            <figure class="legal-sidebar__triangle-btn"></figure>
          </li>
          <app-use-policy
            *ngIf="activeTab === 'SipSignal Acceptabl Use Policy'"
            class="legal__table legal__table_mobile"
          >
          </app-use-policy>
          <li class="legal-sidebar__item">
            <a
              [class.legal-sidebar__item-link_active]="
                activeTab === 'SipSignal VoIP Service'
              "
              (click)="selectTable('SipSignal VoIP Service')"
              class="legal-sidebar__item-link"
              >SipSignal VoIP Service</a
            >
            <figure class="legal-sidebar__triangle-btn"></figure>
          </li>
          <app-voip-service
            *ngIf="activeTab === 'SipSignal VoIP Service'"
            class="legal__table legal__table_mobile"
          >
          </app-voip-service>
        </ul>
        <!-- /.legal-sidebar__items-list -->
      </div>
      <!-- /.legal-sidebar -->

      <app-cancellation-policy
        id="orders"
        *ngIf="activeTab === 'Cancellation Policy'"
        class="legal__table"
      ></app-cancellation-policy>
      <app-calling-policy
        id="users"
        *ngIf="activeTab === 'E911 Calling Policy'"
        class="legal__table"
      ></app-calling-policy>
      <app-use-policy
        id="products"
        *ngIf="activeTab === 'SipSignal Acceptabl Use Policy'"
        class="legal__table"
      ></app-use-policy>
      <app-voip-service
        id="products"
        *ngIf="activeTab === 'SipSignal VoIP Service'"
        class="legal__table"
      ></app-voip-service>
    </div>
    <!-- /.orders__content -->
  </div>
  <!-- /.container container__orders -->
</div>
<!-- /.legal -->
